(() => {
  if (customElements.get('policy-center-sidebar')) return;
  customElements.define('policy-center-sidebar', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const header = document.querySelector('.m-header__wrapper');
      const update = () => {
        const bottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
        this.style.setProperty('--policy-top', `${Math.round(bottom) + 12}px`);
      };
      const schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(update);
      };
      window.addEventListener('scroll', schedule, { passive: true, signal: this.controller.signal });
      window.addEventListener('resize', schedule, { passive: true, signal: this.controller.signal });
      if (header) {
        this.observer = new ResizeObserver(schedule);
        this.observer.observe(header);
        header.addEventListener('transitionend', schedule, { signal: this.controller.signal });
      }
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
})();
